import { LayoutProps, and, computeLabel, rankWith, uiTypeIs } from '@jsonforms/core'
import { JsonFormsDispatch, useJsonForms, withJsonFormsLayoutProps } from '@jsonforms/react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, styled } from 'opensolar-ui'
import React, { useState } from 'react'

const accordionGroupTester = rankWith(100, and(uiTypeIs('AccordionGroup')))

const StyledAccordion = styled(Accordion, { name: 'StyledAccordion' })({
  marginBottom: '15px !important',
  '&.Mui-expanded': {
    marginBottom: '15px !important',
  },
})

const StyledAccordionSummary = styled(AccordionSummary, { name: 'StyledAccordionSummary' })({
  '& .OSUI-AccordionSummary-content': {
    fontWeight: 'bold !important',
  },
})

const BoldLabel = styled('span', { name: 'BoldLabel' })({
  fontWeight: 'bold !important',
})

const AccordionGroupRenderer: React.FC<LayoutProps> = ({ uischema, schema, path, visible }) => {
  const ctx = useJsonForms()
  const { renderers, cells } = ctx || {}

  const label = computeLabel((uischema as any).label || '', false, false) || ''
  const defaultExpanded = (uischema as any).options?.defaultExpanded !== false

  const [expanded, setExpanded] = useState(defaultExpanded)

  const handleChange = (_event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded)
  }

  if (!visible) {
    return null
  }

  const groupElements = (uischema as any).elements || []
  if (!groupElements || groupElements.length === 0) {
    return null
  }

  const elementsUISchema = {
    type: 'VerticalLayout',
    elements: groupElements,
  }

  return (
    <StyledAccordion expanded={expanded} onChange={handleChange}>
      <StyledAccordionSummary expandIcon={<ExpandMoreIcon />}>
        <BoldLabel>{label}</BoldLabel>
      </StyledAccordionSummary>
      <AccordionDetails>
        <JsonFormsDispatch
          schema={schema}
          uischema={elementsUISchema}
          path={path}
          renderers={renderers}
          cells={cells}
        />
      </AccordionDetails>
    </StyledAccordion>
  )
}

const AccordionGroupRendererWithProps = withJsonFormsLayoutProps(AccordionGroupRenderer)

export default [
  {
    tester: accordionGroupTester,
    renderer: AccordionGroupRendererWithProps,
  },
]
